module.exports = __webpack_public_path__ + "static/ui-classic-e18ecd90907bd5c2d144565cf5abf388.svg";